import React from 'react';
import DashboardSidebar from '../components/DashboardComponents/DashboardSidebar';
import AdminBlogsList from '../components/AdminComponents/AdminBlogsList';
import InnerBanner from '../components/PagesComponents/InnerBanner';
const AdminBlogs = () => {
 return (
    <>
    {/*<InnerBanner pageKey="adminBlogs" />*/}
      <section className='profile-sec py-5'>
        <div className='container'>
            <div className='row'>
                <div className='col-lg-12'>
                     <AdminBlogsList/>
                </div>
               
            </div>
        </div>
      </section>
    </>
 );

};

export default AdminBlogs;
